import React, { useState } from "react";
import { Button, Modal, Input } from "antd";
// import CallIcon from "@mui/icons-material/Call";
import { Link } from "react-router-dom";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Container } from "react-bootstrap";
import CreateIcon from "@mui/icons-material/Create";

const LoginOtp = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };
  return (
    <div>
      <Link className="redirect-btn"   to="" onClick={showModal}> 
        Proceed
      </Link>
      <Modal
        // className="login-modal-section "
        // title={props.title}
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        centered=" true"
        title={null}
        header={null}
        footer={null}
      >
        <Container className="main-loginOtp-section">
          <Row >
            <Col className="d-flex">
              {/* <img src={IconCity} alt="city-icon"   /> */}
              <CreateIcon className="create-icon" />
              <p className="m-0 p-0  px-3 otp-title ">Enter OTP</p>
            </Col>
          </Row>

          <Row className="mt-3 ">
            <Col>
              <span className="otp-number ">
                OTP was sent to +91XXXXXXXXX
              </span>
            </Col>
          </Row>

          <Row className="mt-3">
            <Col >
              {/* <span className="input-icon  ">
                <CallIcon className="path-phone-outline" />
              </span> */}
                  <CreateIcon className="input-icon" />
              <Input

                placeholder="Enter OTP"
                className=" p-3 px-5 search-city  otp-input"
              />
            </Col>
          </Row>

          <Row className="m-4">
            <Col >
              <div className="d-flex flex-column justify-content-center align-items-center ">
              <Link to="/createprofile">

          
                <Button type="primary" className="proceed-btn  ">
                 Continue
                </Button>
                </Link>
              </div>
            </Col>
          </Row>

          <Row className=" mb-3 ">
            <Col>
              <div className="get-otp-text">
                <p>
                  {" "}
                   <span> Resend OTP</span> Yout OTP expires in 00:50
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </Modal>
    </div>
  );
};

export default LoginOtp;
